import React, { useState, useEffect } from 'react';
import { List, Card, Icon, Header } from 'semantic-ui-react';
import { useNavigate } from 'react-router-dom';
import { RoundedCard, CompactList } from './components/SharedStyles';
import * as api from './services/api';

const OwnedDiditList = ({ isCompactMode, onTaskClick }) => {
    const [tasks, setTasks] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchOwnedTasks = async () => {
            try {
                const data = await api.getOwnedTasks();
                setTasks(data);
            } catch (error) {
                console.error('Error fetching owned tasks:', error);
            }
        };
        fetchOwnedTasks();
    }, []);

    const handleTaskClick = (task) => {
        navigate(`/?p=${task.uuid}`);
        onTaskClick(task);
    };

    const renderCompactView = () => (
        <CompactList>
            {tasks.map(task => (
                <List.Item key={task.uuid} onClick={() => handleTaskClick(task)}>
                    <div>
                        <span className="task-label">{task.label}</span>
                        {task.created && (
                            <span className="due-date">{new Date(task.created).toLocaleDateString()}</span>
                        )}
                        {task.due > 0 && (
                            <span className="due-date">{new Date(task.due).toLocaleDateString()}</span>
                        )}
                    </div>
                </List.Item>
            ))}
        </CompactList>
    );

    const renderDetailView = () => (
        <Card.Group stackable doubling>
            {tasks.map(task => (
                <RoundedCard key={task.uuid} onClick={() => handleTaskClick(task)}>
                    <Card.Content>
                        <Card.Header>{task.label}</Card.Header>
                        <Card.Description>{task.content}</Card.Description>
                        {task.created && (
                            <Card.Meta>Created: {new Date(task.created).toLocaleDateString()}</Card.Meta>
                        )}
                        {task.due > 0 && (
                            <Card.Meta>Due: {new Date(task.due).toLocaleDateString()}</Card.Meta>
                        )}
                    </Card.Content>
                </RoundedCard>
            ))}
        </Card.Group>
    );

    return (
        <div>
            <Header as='h2'>
                <Icon style={{ marginRight: '5px' }}>
                    <img src="../ownership.svg" alt="Owned" style={{width: '32px', height: '32px'}} />
                </Icon>
                <Header.Content>Owned Didits</Header.Content>
            </Header>
            {tasks.length > 0 ? (
                isCompactMode ? renderCompactView() : renderDetailView()
            ) : (
                <p>No tasks currently owned</p>
            )}
        </div>
    );
};
  
export default OwnedDiditList;